// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useContext } from 'react';
import CommonContext from '../../contexts/CommonContext';
import Multilang from './Multilang';

interface Props {
  id: number;
  lang?: string;
}

export default function(props: Props) {
  const common = useContext(CommonContext);
  const domain = common.domains.find(domain => domain.id === props.id)

  return (
    <Multilang value={domain?.names} lang={props.lang} />
  )
}
